class ProductReviews extends HTMLElement {
  constructor() {
    super();

    this.etrustedWidget = null;
    this.etrustedProductReviewListWidget = null;
    this.observer = null;
  }

  connectedCallback() {
    this.etrustedWidget = this.querySelector("etrusted-widget");

    if (!this.etrustedWidget) return;

    const accentColor = getComputedStyle(this)
      .getPropertyValue("--color-accent")
      .trim();

    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          this.setCustomStyle(accentColor);
        }
      }
    };

    this.observer = new MutationObserver(callback);
    this.observer.observe(this.etrustedWidget, {
      attributes: true,
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  setCustomStyle(accentColor) {
    this.etrustedProductReviewListWidget = this.etrustedWidget.application;

    if (!this.etrustedProductReviewListWidget) return;

    this.etrustedProductReviewListWidget.setAttribute(
      "style",
      `--accent-color: ${accentColor};`,
    );
  }
}

customElements.define("product-reviews", ProductReviews);
